import React from 'react';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SimpleBarReact from 'simplebar-react';
import { faBuilding } from '@fortawesome/free-regular-svg-icons';
import moment from 'moment';

function getExperience(currentlyWork, startDate, endDate) {
  if (currentlyWork) {
    return 'Present';
  } else {
    const start = new Date(startDate);
    const end = new Date(endDate);

    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    const years = Math.floor(diffDays / 365);
    const months = Math.floor((diffDays % 365) / 30);

    let output = '';
    if (years > 0) {
      output += years + ' y ';
    }
    if (months > 0) {
      output += months + ' m';
    }

    return output.trim();
  }
}

const Activity = ({
  activity: { company, title, positionType, startDate, endDate, currentlyWork },
  isLast
}) => {
  const titleName = `${company} (${title})`;
  const description = `${moment(startDate).format('MM-DD-YYYY')}-${moment(
    endDate
  ).format('MM-DD-YYYY')}`;
  const position = positionType;

  return (
    <div className="timeline-item position-relative">
      <Row className="g-0 align-items-center">
        <Col xs="auto" className="d-flex align-items-center">
          <h6 className="timeline-item-date fs-11 text-500 text-truncate mb-0 me-1">
            {getExperience(currentlyWork, startDate, endDate)}
          </h6>
          <div className="position-relative">
            <div className="icon-item icon-item-md rounded-7 shadow-none bg-200">
              <FontAwesomeIcon icon={faBuilding} className="text-primary" />
            </div>
          </div>
        </Col>
        <Col className="ps-3 fs-10 text-500">
          <div className="py-x1">
            <h5 className="fs-10">{titleName}</h5>
            <p className="mb-0">{position}</p>
            <p className="mb-0">{description}</p>
          </div>
          {!isLast && <hr className="my-0 text-200" />}
        </Col>
      </Row>
    </div>
  );
};

const WorkExperience = ({ data }) => {
  return (
    <Card className="h-100">
      <FalconCardHeader
        light
        title="Work Experience"
        titleTag="h5"
        className="py-2"
        // endEl={<CardDropdown />}
      />
      <SimpleBarReact style={{ height: '25rem' }} className="flex-1">
        <Card.Body className="py-0">
          <div className="timeline-simple">
            {data?.map((activity, index) => (
              <Activity
                key={index}
                activity={activity}
                isLast={index === data.length - 1}
              />
            ))}
          </div>
        </Card.Body>
      </SimpleBarReact>
    </Card>
  );
};

Activity.propTypes = {
  activity: PropTypes.any,
  isLast: PropTypes.bool
};

WorkExperience.propTypes = {
  data: PropTypes.arrayOf(Activity.propTypes.activity)
};

export default WorkExperience;
